export const START = 'START';
export const TOP_FIXED = 'TOP_FIXED';
export const UNFIXED = 'UNFIXED';
export const BOTTOM_FIXED = 'BOTTOM_FIXED';
export const FINISH = 'FINISH';
